<template>
<div>
<el-dialog
      title=""
      :visible.sync="showSuccessText"
      :modal-append-to-body="false"
      :show-close="false"
      class="delEmployDio"
      :close-on-click-modal="false"
      width="660px"
      center
    >
      <div class="ico-success"></div>
      <div class="txt-success">The doshii account is connected successfully!</div>
      <div class="align-center">
        <button @click="confirm('next')" class="doshii-alert-confirm-button">Confirm</button>
      </div>
</el-dialog>

<el-dialog
      title=""
      :visible.sync="showBooleanChoose"
      :modal-append-to-body="false"
      :show-close="false"
      class="delEmployDio"
      :close-on-click-modal="false"
      width="840px"
      center
    >
      <div class="ico-success"></div>
      <div class="txt-success mar-btm-30">The doshii account is connected successfully!</div>
      <div class="txt-success mar-btm-50">Do you need to obtain revenue data of a specified area?</div>
      <div class="align-center">
        <button class="doshii-alert-lft-button" @click="booChoose('no')">No<i v-if="saving" class="el-icon-loading"></i></button>
        <button class="doshii-alert-rgt-button" @click="booChoose('yes')">Yes</button>
      </div>
</el-dialog>

<el-dialog
      title=""
      :visible.sync="showAreaSelect"
      :modal-append-to-body="false"
      :show-close="false"
      class="delEmployDio"
      :close-on-click-modal="false"
      width="840px"
      center
    >
      <div class="main-tit" style="text-align: left">
        Please select area
      </div>
      <div class="sub-tit" style="margin-bottom: 50px">
        Multiple choice
      </div>
      <div class="area-list-container">
        <div
          class="area-check clear"
          @click="operateAll"
          :class="{ 'area-checked': allSelected }">
          All Areas
        </div>
        <div
          class="area-check clear"
          v-for="(item, index) in checkOptions"
          @click="operateOne(index)"
          :key="index"
          :class="{ 'area-checked': item.selected }">
          {{ `${item.name} - ${item.area} ( ${item.doshiiId} )` }}
        </div>
      </div>
      <div class="align-center pad-top-35">
        <button class="doshii-alert-confirm-button" @click="booChoose('continue')">Continue<i v-if="saving" class="el-icon-loading"></i></button>
      </div>
</el-dialog>

<el-dialog
      title=""
      :visible.sync="showAreaSet"
      :modal-append-to-body="false"
      :show-close="false"
      class="delEmployDio"
      :close-on-click-modal="false"
      width="660px"
      center
    >
      <div class="ico-success"></div>
      <div class="txt-success">The area is set successfully!<br />
        Afterwards you can modify it through the<br />revenue history page.</div>
      <div class="align-center">
        <button @click="confirm('close')" class="doshii-alert-confirm-button">Confirm</button>
      </div>
</el-dialog>

</div>
</template>

<script>
import api from "../../../api/income";

export default {
    name: 'dashiiAlert',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    data() {
      return {
          showSuccessText: this.show,
          showBooleanChoose: false,
          // 选择区域
          showAreaSelect: false,
          // 区域列表
          checkOptions: this.list,
          showAreaSet: false,
          saving: false,

          allSelected: false
      }
    },
    methods:{
        operateAll() {
          var that = this
          that.list.forEach(item => {
            item.selected = !that.allSelected ? true : false
          })
          that.allSelected = !that.allSelected
        },
        operateOne(index) {
          var that = this
          that.list[index].selected = !that.list[index].selected
          that.validateIfAllSElected()
        },
        validateIfAllSElected() {
          var that = this
          let lgt = 0
          that.list.forEach(item => {
            if (item.selected)
              lgt ++
          })
          if (that.list.length === lgt) {
            that.allSelected = true
          } else {
            that.allSelected = false
          }
        },
        confirm(type) {
            var that = this
            if (type === 'next') {
                that.showSuccessText = false
                that.showBooleanChoose = true
            } else {
                that.showAreaSet = false
            }
        },
        booChoose(type) {
            var that = this
            // 选择yes，打开区域选择
            if (type === 'yes') {
              if (that.saving)
                return
              that.showBooleanChoose = false
              that.showAreaSelect = true
            } else if (type === 'no') {
                //that.showBooleanChoose = false
                // that.showAreaSelect = true
                if (that.saving)
                  return
                that.saving = true
                that.checkOptions.forEach((item) => {
                  item.selected = true
                })
                that.update('no')
            } else if (type === 'continue') {
              if (that.saving)
                return
              that.saving = true
              that.update()
            }
        },
        update(type) {
          var that = this
          let params = []
          this.checkOptions.forEach(i => {
            if (i.selected)
              params.push(i)
          })
          api.alterAreas({
              params: params,
              callback: (res) => {
                  let {data, code, message} = res.data
                  that.saving = false
                  if (code === 0) {
                      that.showAreaSelect = false
                      that.showBooleanChoose = false
                      if (!type)
                        that.showAreaSet = true
                  } else {
                      Utils.alert('', message ,'error')
                  }
              }
          })
        }
    },
    watch: {
        'show': {
            deep: true,
            handler: function (val) {
              if (val)
                this.showSuccessText = val
            }
        },
        'list': {
            deep: true,
            handler: function (val) {
              this.checkOptions = this.list
            }
        },
    }
}
</script>

<style lang="scss" scope>
.ico-success{
    width: 100%;
    height: 70px;
    margin-bottom: 40px;
    background-repeat: no-repeat;
    background-position: center 10px;
    background-size: 60px auto;
    background-image: url("../../../assets/success.png");
}
.txt-success{
    font-size: 24px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: var(--text-color);
    line-height: 28px;
    margin-bottom: 50px;
    text-align: center;
}
.mar-btm-30{
    margin-bottom: 30px;
}
.mar-btm-50{
    margin-bottom: 50px;
}
.align-center{
    text-align: center;
    padding-bottom: 38px;
    .doshii-alert-confirm-button{
        width: 310px;
        height: 60px;
        background: var(--background-color-4);
        border: 2px solid #EA3796;
        height: 50x;
        font-size: 20px;
        font-family: SF Pro Text-Semibold, SF Pro Text;
        font-weight: 600;
        color: #EA3796;
        box-sizing: border-box;
        cursor: pointer;
        .el-icon-loading{
          margin-left: 5px;
        }
    }
    .doshii-alert-lft-button{
        width: 280px;
        height: 60px;
        background: var(--background-color-4);
        border: 2px solid var(--text-color);
        box-sizing: border-box;
        font-size: 26px;
        font-family: PingFang SC-Semibold, PingFang SC;
        color: var(--text-color);
        margin-right: 50px;
        cursor: pointer;
        .el-icon-loading{
          margin-left: 5px;
        }
    }
    .doshii-alert-rgt-button{
        width: 280px;
        height: 60px;
        background: var(--background-color-4);
        border: 2px solid #D13A90;
        font-size: 26px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #D13A90;
        cursor: pointer;
    }
}
.pad-top-35{
    padding-top: 35px;
}
.main-tit {
  width: 100%;
  text-align: center;
  height: 33px;
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color);
  line-height: 33px;
  margin-bottom: 20px;
}
.sub-tit{
    width: 100%;
    height: 28px;
    font-size: 20px;
    font-weight: 400;
    color: var(--text-color);
    line-height: 28px;
    margin: 10px 0 22px 0;
}
.area-check{
  word-break: break-word;
  box-sizing: border-box;
  padding: 14px 0 14px 46px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: var(--text-color);
  line-height: 32px;
  background-repeat: no-repeat;
  background-position: 10px center;
  background-size: 16px 16px;
  background-image: url("../../../assets/p2.png");
  cursor: pointer;
}
.area-checked{
  background-image: url("../../../assets/p1.png") !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/component/doshiiAlert.vue